import { toast } from "react-toastify";

import { ConfirmUserRequestActionType } from "../types";
import { AuthService } from "../../../services/auth";

export function* confirmUserSaga({ payload: { code } }: ConfirmUserRequestActionType) {
    const id: number = yield toast("Please Wait...");

    try {
        yield AuthService.confirmUser(code);
        yield toast.update(id, {
            render: "Your account confirmed. Enjoy",
            type: "success",
            isLoading: false,
            autoClose: 10000,
        });
    } catch (error) {
        yield toast.update(id, {
            render: "Something wrong with your confimation. Try again",
            type: "error",
            isLoading: false,
            autoClose: 10000,
        });
    }
}
